import { render, staticRenderFns } from "./CardsComponent.vue?vue&type=template&id=6786c90f"
import script from "./CardsComponent.vue?vue&type=script&lang=js"
export * from "./CardsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports